import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-signage-edit',
    templateUrl: './breadcrumb.signage.edit.component.html'
})

export class BreadcrumbSignageEditComponent {
    @Input() companyId: number;
    @Input() facilityId: number;
    @Input() kioskId: number;
    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
